import { gql } from '@apollo/client';

export default gql`
  mutation CreatePropertyVisit(
    $record: CreateOnePropertyVisitInput!
    $buyerRecord: CreateOneBuyerInput
  ) {
    createPropertyVisit(record: $record, buyerRecord: $buyerRecord) {
      recordId
    }
  }
`;
